/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Team member profile.
 * @export
 * @interface GetClientTeammember200Response
 */
export interface GetClientTeammember200Response {
    /**
     * Keycloak user UUID.
     */
    id?: string;
    /**
     * 
     */
    firstName?: string;
    /**
     * 
     */
    lastName?: string;
    /**
     * 
     */
    email?: string;
}

/**
 * Check if a given object implements the GetClientTeammember200Response interface.
 */
export function instanceOfGetClientTeammember200Response(value: object): value is GetClientTeammember200Response {
    return true;
}

export function GetClientTeammember200ResponseFromJSON(json: any): GetClientTeammember200Response {
    return GetClientTeammember200ResponseFromJSONTyped(json, false);
}

export function GetClientTeammember200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientTeammember200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function GetClientTeammember200ResponseToJSON(json: any): GetClientTeammember200Response {
    return GetClientTeammember200ResponseToJSONTyped(json, false);
}

export function GetClientTeammember200ResponseToJSONTyped(value?: GetClientTeammember200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
    };
}

